import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr10 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа при покривни работи
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1 .Покривните работи</b>, полагане на изолации, монтаж на антени и гръмоотводи и други
        работи по покриви на сгради и съоръжения се извършват само след като се вземат мерки за
        осигуряване на безопасността на работниците срещу падане от височина, падане на предмети или
        други опасности.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2 .Допускането на служители </b>до изпълнение на покривни работи да се разрешава от
        техническия ръководител /ръководител група, екип/на обекта след:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • извършване на проверка за здравината на носещите елементи (форми, ребра, обшивки и
          други), както и определяне на местата за закачване на предпазните колани на работниците;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • ограждане на опасната зона около сградата или съоръжението и обезопасяване на отворите
          по покрива;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • поставяне на предпазни козирки над всички входове и проходи в опасната зона;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • поставяне по оградата, пред входовете и проходите на знаци или табели със съответните
          надписи
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • провеждане на ежедневен инструктаж
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. При работа на покрив </b>да се ползват лични предпазни средства - каска, обувки с
        ходила устойчиви на подхлъзване, удар.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4.3а приемане и временно складиране</b> на материали на покрива да се устройват приемни
        площадки на местата, посочени в проекта.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5 .Складираните на площадката материали</b>, инструменти и други да се подреждат и да се
        осигуряват срещу подхлъзване, търкаляне, падане, изтичане, разпиляване или преобръщане от
        вятър.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6 .След извършване на работната смяна </b>или при прекъсване на работата останалите
        материали, празният амбалаж, отпадъците, инструменти и други подобни да се свалят от
        покрива.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7 .Във вертикалния обсег </b>на извършваните покривни работи се забранява изпълнението на
        други видове външни работи на по-нисък хоризонт от сградата или съоръжение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8 .При изпълнение на куполообразни покриви</b> или такива с наклон по- голям от 30°, в
        ПОИС да се предвиждат допълнителни мероприятия по обезопасяването, като работни платформи,
        парапети и други подобни.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9 .Работниците, извършващи работи</b> в близост до контура на плоски покриви или покриви
        с наклон над 20°, както и до необезопасени отвори да ползват предпазни колани и обувки с
        неплъзгащи се подметки.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10 .Работещите на покриви</b> с наклон над 20° или по покриви, които не са оразмерени за
        временно допълнително натоварване, да ползват за движение и пренос на материали върху
        покрива стълби с ширина не по- малко от 0,3 метра, имащи напречни планки през 0,4 метра.
        Стълбите да са сигурно закрепени към покрива.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          11 .<span style={styles.warning}>Забранява се </span>
        </b>
        извършването на покривни работи по наклонени покриви, които са овлажнени, както и при дъжд,
        снеговалеж, поледици, гръмотевична дейност, вятър със скорост над 10 м/s, намалена видимост
        в границите на работното място, както и на изкуствено осветление.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12 .Издигането и свалянето</b> на и от височина на всякакъв вид товари се извършва по
        механизиран начин.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13 .Обслужването на товароподемните устройства</b> и съоръжения се възлага само на
        предварително обучени, изпитани и снабдени с документ за правоспособност лица.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14 .Площадките на товароподемните устройства </b>и приемателните площадки се ограждат с
        предпазни парапети.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>15 .Не се допуска използването на повдигателни съоръжения</b>, които не отговарят на
        изискванията за безопасното им функциониране.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>16 .Всички служители, работещи по покривите</b>, трябва да отговарят на медицинските
        изисквания, да не са употребили алкохол или упойващи вещества.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr10;
